"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getDefinable_1 = __importDefault(require("./getDefinable"));
const getImageSource = (slug) => (0, getDefinable_1.default)({
    className: "ImageSource",
    slug
});
exports.default = getImageSource;
